import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { untilDestroyed } from '@ngneat/until-destroy';

(untilDestroyed)
@Component({
  selector: 'cookieconsent-dialog',
  templateUrl: './cookieconsent-dialog.component.html',
  styleUrls: ['./cookieconsent-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieConsentDialogComponent implements OnInit {

  constructor(
    private readonly dialogRef: MatDialogRef<CookieConsentDialogComponent>,

    private readonly cdr: ChangeDetectorRef) {

  }

  public ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  public onNoClick(): void {
    this.dialogRef.close(false);
  }

  public onTrueClick(): void {
    this.dialogRef.close(true);
  }
}